import { useEffect } from "react";
import { useSelector } from "react-redux";
import { connectSocket, getSocket, disconnectSocket } from "../services/socket";

const useSocket = () => {
  const { token } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!token) return;

    const socket = connectSocket(token);

    socket.on("connect", () => {
      console.log("Socket Connected:", socket.id);
    });

    socket.on("disconnect", () => {
      console.log("Socket Disconnected");
    });

    return () => {
      disconnectSocket();
    };
  }, [token]);

  return getSocket();
};

export default useSocket;